import { useEffect, useMemo, useState } from "react";
import { PanelShell } from "../PanelShell";
import "../../assets/stylesheets/upload.css";
import { sortAlphabetically } from "../../utils/sorting";
import { UploadDropzone } from "./UploadDropzone";
import { UploadPanelHeader } from "./UploadPanelHeader";
import { UploadQueuePanel } from "./UploadQueuePanel";
import { getStagedFileCount } from "./uploadPanelUtils";
import { useUploadQueue } from "./useUploadQueue";
import { useMe } from "../../hooks/useMe";

export const UploadPanel: React.FC = () => {
  const me = useMe();
  const [origin, setOrigin] = useState<string | undefined>(undefined);
  const { files, addFiles, removeFile, uploadFile, uploadAll, reset } =
    useUploadQueue();
  const sortedOrganizations = useMemo(
    () => sortAlphabetically(me?.organizations ?? []),
    [me?.organizations],
  );
  const stagedFileCount = getStagedFileCount(files);

  useEffect(() => {
    if (sortedOrganizations.length > 0 && !origin) {
      setOrigin(sortedOrganizations[0]);
    }
  }, [sortedOrganizations, origin]);

  return (
    <PanelShell
      className="focusoc-upload-shell h-full"
      contentClassName="grid min-h-0 flex-1 grid-cols-1 gap-3 overflow-hidden p-3 lg:grid-cols-[minmax(260px,0.9fr)_minmax(320px,1.1fr)]"
      header={
        <UploadPanelHeader
          canUpload={stagedFileCount > 0}
          fileCount={files.length}
          onOriginChange={setOrigin}
          onReset={reset}
          onUploadAll={uploadAll}
          organizations={sortedOrganizations}
          origin={origin}
          stagedFileCount={stagedFileCount}
        />
      }
    >
      <UploadDropzone onAddFiles={addFiles} origin={origin} />
      <UploadQueuePanel
        files={files}
        onRemoveFile={removeFile}
        onUploadFile={uploadFile}
      />
    </PanelShell>
  );
};
